<template>
  <el-drawer
    :title="rowdata.ClientName"
    size="60%"
    :visible.sync="isVisible"
    @open="getDetailedReport"
    @close="onDrawerClose"
  >
    <el-row :gutter="10" class="filaPrinc">
      <el-row :gutter="2">
        <el-col :span="3">
          <span>Codigo del Cliente: </span>
        </el-col>
        <el-col :span="5">
          <span class="black-text font-weight-800">{{
            rowdata.ClientCode
          }}</span>
        </el-col>
        <el-col :offset="3" :span="3">
          <span>Direccion:</span>
        </el-col>
        <el-col :span="5">
          <span class="black-text font-weight-800">{{
            DetailData.TraccarDeviceUniqueId
          }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="2">
        <el-col :span="3">
          <span>Telefono: </span>
        </el-col>
        <el-col :span="5">
          <span class="black-text font-weight-800">{{
            rowdata.ClientCode
          }}</span>
        </el-col>
        <el-col :offset="3" :span="3">
          <span>Coreo electronico:</span>
        </el-col>
        <el-col :span="5">
          <span class="black-text font-weight-800">{{
            DetailData.TraccarDeviceUniqueId
          }}</span>
        </el-col>
      </el-row>
    </el-row>
    <el-container>
      <el-main>
        <el-row>
          <div class="card-base card-shadow--medium">
            <rabbey-table-3 :data="DetailData" :columns="columns" />
          </div>
        </el-row>
      </el-main>
    </el-container>
  </el-drawer>
</template>

<script>
//import { columns } from '@/components/deals/deal'
export default {
  name: "TraccarGpsReportDetail",
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    rowdata: {
      type: Object,
      default: () => {}
    },
    columnname: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isVisibleDetail: true,
      DetailData: [],
      columns: [
        {
          prop: "TraccarDeviceID",
          label: "Id del dispositivo",
          align: "center",
          fixed: true,
          sortable: true,
          width: "155"
        },
        {
          prop: "TraccarDeviceName",
          label: "Dispositivo",
          fixed: true,
          sortable: true,
          width: "170"
        },
        {
          prop: "TraccarDeviceModel",
          label: "Modelo",
          //fixed: true,
          sortable: true,
          width: "150"
        },
        {
          prop: "TraccarDeviceUniqueId",
          label: "Serial",
          //fixed: true,
          sortable: true,
          width: "150"
        },

        {
          prop: "TraccarDevicePhone",
          label: "Numero Telefononico",
          //fixed: true,
          sortable: true,
          width: "190"
        },
        {
          prop: "TraccarDeviceStatus",
          label: "Estado",
          align: "center",
          //fixed: true,
          sortable: true,
          width: "150"
        },
        {
          prop: "TraccarDeviceLastUpdate",
          label: "Ultima actualizacion",
          //fixed: true,
          sortable: true,
          width: "180"
        },
        {
          prop: "TraccarDeviceCategory",
          label: "Categoria",
          //fixed: true,
          sortable: true,
          width: "170"
        }
      ]
    };
  },
  /*
  updated() {
    if (this.isVisible === true) {
        this.getDetailedReport();
    }
    
  },
  */
  methods: {
    onDrawerClose() {
      this.$emit("onDrawerClose", false);
    },
    async getDetailedReport() {
      let params = {
        userId: this.rowdata.TracarUserId,
        status:
          this.columnname === "TotalGps"
            ? null
            : this.columnname === "OnlineGps"
            ? "online"
            : "offline"
      };
      this.$http
        .post("/api/TraccarGPS/GetTraccarGpsReportDetails", params)
        .then((resp) => {
          console.log("Reporte Traccar GPS", resp);
          this.DetailData = resp.data;
        })
        .catch((err) => {
          console.error(
            "Error al consultar el detalle del reporte de GPS Traccar: ",
            err
          );
        })
        .finally(() => {
          //this.loading = false;
        });
    }
  },
  watch: {
    isVisible(val) {
      console.log("IsVisible: ", val);
    }
  }
};
</script>

<style scoped>
.filaPrinc {
  margin-top: 15px;
  margin-left: 15px;
  padding-left: 30px;
  padding: true;
}
</style>
